
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.29501 15.7053C5.68836 16.0982 6.3261 16.0982 6.71945 15.7053L12 10.4295L17.2805 15.7053C17.6739 16.0982 18.3116 16.0982 18.705 15.7053C19.0983 15.3123 19.0983 14.6751 18.705 14.2821L12.7122 8.29474C12.3189 7.90175 11.6811 7.90175 11.2878 8.29474L5.29501 14.2821C4.90166 14.6751 4.90166 15.3123 5.29501 15.7053Z","fill":"#10001F"}})])
          )
        }
      }
    